import { useState, useEffect } from "react";
import profileLogo from '../../assets/logo.png';

const Header = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const handleMenuItemClick = (sectionId) => {
    setIsOpen(false); // Close mobile menu on click
    const section = document.getElementById(sectionId);
    if (section) {
      section.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <nav
      className={`fixed top-0 w-full z-10 transition duration-300 ${isScrolled ? "bg-[#050414] bg-opacity-50 backdrop-blur-md" : "bg-transparent"
        }`}
    >
      {/* Increased padding-y (py-16 or more) to fully accommodate the tall logo */}
      <div className="max-w-7xl mx-auto px-6 md:px-10 lg:px-20 py-16 flex items-center justify-between"> 

        {/* Left Section: Mobile Menu Icon / Desktop Social Icons */}
        {/* Added relative z-50 to ensure the menu icon is above the logo */}
        <div className="flex items-center w-auto md:w-200 justify-start relative z-50"> 
          
          {/* Desktop social icons (if you intend to have them here) */}
        </div>

        {/* Center Section: Logo (visible on all screens, always centered) */}
        {/* Adjusted z-index to be lower than the mobile menu icon's parent */}
        <div className="absolute left-1/2 transform -translate-x-1/2 z-40"> 
          <a href="/" className="flex items-center">
            <img
              src={profileLogo}
              alt="Momo.com Logo"
              className="h-32 w-auto" // Large logo size (128px height)
            />
          </a>
        </div>

        {/* Right Section: Empty placeholder for balance, or other elements */}
        <div className="w-auto md:w-20"> {/* This div should match the space occupied by the left elements */}
          {/* You can add another button or more icons here if needed */}
        </div>
      </div>

      {/* Mobile Dropdown Menu (only on small screens) */}
      {/* The content of this div is now empty as requested */}
      
    </nav>
  );
};

export default Header;